<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Date</em>
				<span class="mgr_15"> <CustomDatePicker v-model="date" /> </span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<span v-if="searched">
					<a href="javascript:void(0);" class="gray_bt mgl_15" @click="excel()">Excel</a>
				</span>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<table class="list_tbl dts-tbl" id="dailyTransactionSummary" style="max-width: 900px;">
					<colgroup>
						<col style="width: 34%;" />
						<col style="width: 18%;" />
						<col style="width: 16%;" />
						<col style="width: 16%;" />
						<col style="width: 16%;" />
					</colgroup>

					<!-- Section 1: Sales by Shipping Method -->
					<tbody>
						<tr class="dts-section">
							<td colspan="5" class="al_left"><b>SALES (by Shipping Method)</b></td>
						</tr>
						<tr class="dts-head">
							<th class="al_left">Shipping Method</th>
							<th class="al_right">Amount</th>
							<th class="al_right">Discount</th>
							<th class="al_right">Freight</th>
							<th class="al_right">Total</th>
						</tr>
						<tr v-for="(row, i) in sales" :key="'s' + i">
							<td class="al_left">{{ row.delivery_type_name }}</td>
							<td class="al_right">{{ row.sales_amount | toCurrency }}</td>
							<td class="al_right">{{ row.discount_amount | toCurrency }}</td>
							<td class="al_right">{{ row.freight_amount | toCurrency }}</td>
							<td class="al_right">{{ row.total_amount | toCurrency }}</td>
						</tr>
						<tr v-if="searched && !sales.length">
							<td colspan="5" class="al_center">No data</td>
						</tr>
						<tr class="dts-total">
							<td class="al_left"><b>Total Sales</b></td>
							<td class="al_right">{{ salesSum.sales_amount | toCurrency }}</td>
							<td class="al_right">{{ salesSum.discount_amount | toCurrency }}</td>
							<td class="al_right">{{ salesSum.freight_amount | toCurrency }}</td>
							<td class="al_right">
								<b>{{ salesSum.total_amount | toCurrency }}</b>
							</td>
						</tr>
					</tbody>

					<!-- Section 2: Customer Payment by Pay Type -->
					<tbody>
						<tr class="dts-spacer">
							<td colspan="5">&nbsp;</td>
						</tr>
						<tr class="dts-section">
							<td colspan="5" class="al_left"><b>CUSTOMER PAYMENT (by Pay Type)</b></td>
						</tr>
						<tr class="dts-head">
							<th class="al_left">Pay Type</th>
							<th></th>
							<th></th>
							<th></th>
							<th class="al_right">Total</th>
						</tr>
						<tr v-for="(row, i) in receipts" :key="'r' + i">
							<td class="al_left">{{ row.receipt_type_name }}</td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">{{ row.total_amount | toCurrency }}</td>
						</tr>
						<tr v-if="searched && !receipts.length">
							<td colspan="5" class="al_center">No data</td>
						</tr>
						<tr class="dts-total">
							<td class="al_left"><b>Total Payment</b></td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">
								<b>{{ receiptSum | toCurrency }}</b>
							</td>
						</tr>
					</tbody>

					<!-- Section 3: Purchase by Vendor -->
					<tbody>
						<tr class="dts-spacer">
							<td colspan="5">&nbsp;</td>
						</tr>
						<tr class="dts-section">
							<td colspan="5" class="al_left"><b>PURCHASE (by Vendor)</b></td>
						</tr>
						<tr class="dts-head">
							<th class="al_left">Vendor</th>
							<th></th>
							<th></th>
							<th></th>
							<th class="al_right">Total</th>
						</tr>
						<tr v-for="(row, i) in purchases" :key="'p' + i">
							<td class="al_left">{{ row.vendor_name }}</td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">{{ row.total_amount | toCurrency }}</td>
						</tr>
						<tr v-if="searched && !purchases.length">
							<td colspan="5" class="al_center">No data</td>
						</tr>
						<tr class="dts-total">
							<td class="al_left"><b>Total Purchase</b></td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">
								<b>{{ purchaseSum | toCurrency }}</b>
							</td>
						</tr>
					</tbody>

					<!-- Section 4: A/P Payment by Vendor -->
					<tbody>
						<tr class="dts-spacer">
							<td colspan="5">&nbsp;</td>
						</tr>
						<tr class="dts-section">
							<td colspan="5" class="al_left"><b>A/P PAYMENT (by Vendor)</b></td>
						</tr>
						<tr class="dts-head">
							<th class="al_left">Pay To</th>
							<th></th>
							<th></th>
							<th></th>
							<th class="al_right">Total</th>
						</tr>
						<tr v-for="(row, i) in ap_payments" :key="'a' + i">
							<td class="al_left">{{ row.vendor_name }}</td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">{{ row.total_amount | toCurrency }}</td>
						</tr>
						<tr v-if="searched && !ap_payments.length">
							<td colspan="5" class="al_center">No data</td>
						</tr>
						<tr class="dts-total">
							<td class="al_left"><b>Total A/P Payment</b></td>
							<td></td>
							<td></td>
							<td></td>
							<td class="al_right">
								<b>{{ apSum | toCurrency }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date';
import { apiDailyTransactionSummary } from '@/api/report/report';
import { exportExcel } from '@/api/util';

export default {
	components: {
		CustomDatePicker,
	},
	data: () => ({
		date: today(),
		sales: [],
		receipts: [],
		purchases: [],
		ap_payments: [],
		company_id: null,
		searched: false,
	}),
	computed: {
		salesSum() {
			return this.sales.reduce(
				(acc, r) => {
					acc.sales_amount += Number(r.sales_amount) || 0;
					acc.discount_amount += Number(r.discount_amount) || 0;
					acc.freight_amount += Number(r.freight_amount) || 0;
					acc.total_amount += Number(r.total_amount) || 0;
					return acc;
				},
				{ sales_amount: 0, discount_amount: 0, freight_amount: 0, total_amount: 0 },
			);
		},
		receiptSum() {
			return this.receipts.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0);
		},
		purchaseSum() {
			return this.purchases.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0);
		},
		apSum() {
			return this.ap_payments.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0);
		},
	},
	methods: {
		async search() {
			if (!this.date) return this.$toast.error('Please, Select Date');
			const { data } = await apiDailyTransactionSummary(this.date);
			this.sales = data.sales || [];
			this.receipts = data.receipts || [];
			this.purchases = data.purchases || [];
			this.ap_payments = data.ap_payments || [];
			this.company_id = data.company_id || null;
			this.searched = true;
		},
		excel() {
			exportExcel('dailyTransactionSummary', 'DailyTransactionSummary_' + this.date);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_dailyTransactionSummary');
		this.$store.commit('setSubTitle', 'Report -> Daily Transaction Summary');
	},
};
</script>

<style scoped>
.dts-tbl td,
.dts-tbl th {
	padding: 4px 8px;
}
.dts-section td {
	background: #2d3e50;
	color: #fff;
	font-size: 13px;
}
.dts-head th {
	background: #eef3f8;
}
.dts-total td {
	background: #f7f7f7;
}
.dts-spacer td {
	border: none;
	background: #fff;
}
</style>
